<template>
  <div style="padding: 20px; text-align: left; letter-spacing: 1px">
    <div>
      <!-- <div>{{ "建议标题：" }}</div> -->
      <div class="AdviceTitle1">{{ listInfo.AdviceTitle }}</div>
    </div>
    <div style="display: flex">
      <div class="SendTime1">{{ formatDate(listInfo.SendTime) }}</div>
    </div>
    <van-divider />
    <div>
      <!-- <div :class="[listInfo.checkState == 2 ? 'checkState2' : 'checkState3']">
        {{ listInfo.checkState == 2 ? "已反馈  " : "未反馈" }}
      </div> -->
      <!-- <div>{{ "投诉建议内容：" }}</div> -->
      <el-card>
        <div class="AdviceContent1">
          <!-- {{ "\xa0\xa0\xa0\xa0\xa0\xa0" + listInfo.AdviceContent }} -->
          {{ listInfo.AdviceContent }}
        </div></el-card
      >
    </div>
    <div v-if="listInfo.CheckState == 2" style="margin-top: 8%">
      <el-card class="ss11">
        <div class="FeedbackTitle2">{{ "反馈内容：" }}</div>
        <!-- <div>
        <div class="SendTime1">{{ listInfo.FeedbackTime }}</div>
      </div> -->
        <div class="FeedbackContent1">
          <!-- {{ "\xa0\xa0\xa0\xa0\xa0\xa0" + listInfo.FeedbackContent }} -->
          {{ listInfo.FeedbackContent }}
        </div>
      </el-card>
    </div>

    <!-- <div style="width: 100%">
      <el-button
        type="primary"
        style="width: 92%; margin: 4%; background: #fff; color: #409eff"
        plain
        @click="goBack"
        >返 回</el-button
      >
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Advice",
  data () {
    return {
      listInfo: {}
    };
  },
  watch: {

  },
  created () {
    this.getInfo()
  },
  methods: {
    //时间戳转换方法    date:时间戳数字
    formatDate (date) {
      var date = new Date(date);
      var YY = date.getFullYear() + '-';
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      return YY + MM + DD + " " + hh + mm + ss;
    },
    getInfo () {
      let id = this.getAdviceID()
      this.apiGetAdviceInfoAPIGet({ AdviceID: id }, this, res => {
        if (res.code == 20000) {
          this.listInfo = res.data
        } else {
          this.$toast(res.message);
        }
      });
    },
    goBack () {
      this.$router.push("/AdviceList");
    },
  }
};
</script>

<style scoped>
.AdviceTitle1 {
  font-weight: bold;
  font-size: 20px;
}
.SendTime1 {
  margin: 2% 0;
  color: rgb(138, 138, 138);
  font-size: 13px;
  letter-spacing: 0px;
}
.AdviceContent1 {
  min-height: 40vh;
  font-size: 14px;
  /* padding: 5% 0; */
  line-height: 20px;
}
.FeedbackContent1 {
  /* position: absolute;
  bottom: -30vh; */
  margin: 2% 0;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1px;
  border-radius: 8px;
  min-height: 10vh;
  padding: 2% 0%;
  /* font-weight: bold; */
  color: #d6313f;
  /* height: 25vh; */
}
.FeedbackTitle2 {
  font-weight: bold;
  font-size: 16px;
  color: #d6313f;
}
.checkState2 {
  height: 25px;
  text-align: center;
  line-height: 25px;
  width: 70px;

  color: #d6313f;
  border-radius: 20px;
  font-size: 14px;
}
.checkState3 {
  height: 25px;
  text-align: center;
  line-height: 25px;
  width: 70px;
  background: rgba(201, 201, 201, 0.5);
  color: rgba(70, 70, 70, 0.5);
  border-radius: 20px;
  font-size: 14px;
}
.ss11 {
  background: rgba(214, 49, 63, 0.08);
}
</style>
